const BROWSER_DEVICE_ID_STORAGE_KEY = 'wss-browser-device-id'

/**
 * Stable per-browser profile identifier for user session scoping.
 * Persisted in localStorage so the same browser keeps one active session slot.
 * @returns {string}
 */
export const getOrCreateBrowserDeviceId = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return 'web-anonymous'
  }

  const existing = window.localStorage.getItem(BROWSER_DEVICE_ID_STORAGE_KEY)
  if (typeof existing === 'string' && existing.length > 0) {
    return existing
  }

  const id = typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
    ? `web-${crypto.randomUUID()}`
    : `web-${Date.now()}-${Math.random().toString(36).slice(2)}`

  window.localStorage.setItem(BROWSER_DEVICE_ID_STORAGE_KEY, id)
  return id
}
